import type { GenericServiceParameters } from "~/core/models/GenericServiceParameters.interface";
import LxcError from "~/core/models/LxcError.class";
import type { UserCreateDto } from "~/modules/user/models/UserCreateDto.interface";
import userAdministrationService from "~/modules/user/services/userAdministration.service";

export function useCreateUser({
  businessUnitCode,
  organizationCode,
}: GenericServiceParameters<void>) {
  let service = userAdministrationService.createSuperAdministrationUser.bind(
    userAdministrationService,
  );
  if (organizationCode) {
    service = userAdministrationService.createOrganizationUser.bind(
      userAdministrationService,
    );
  } else if (businessUnitCode) {
    service = userAdministrationService.createBusinessUnitUser.bind(
      userAdministrationService,
    );
  }
  const isLoading = ref<boolean>(false);
  const error = ref<LxcError | null>(null);

  async function createUser(user: UserCreateDto): Promise<void> {
    isLoading.value = true;
    error.value = null;
    const response = await service({
      businessUnitCode,
      organizationCode,
      user,
    });

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    createUser,
    error,
    isLoading,
  };
}
